import PurchasedItem from "../types/PurchasedItem";


const Purchased = () => {
     return (
          <>
               <PurchasedItem />
          </>
     );
}

export default Purchased;